import React from "react";
import Sidebar from "./Sidebar"; // تأكد من أن المسار صحيح
import { Outlet } from "react-router-dom";

const AdminLayout = () => {
  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <Sidebar />
      <div style={{ flex: 1, padding: "20px", backgroundColor: "#f5f6fa" }}>
        <Outlet /> {/* هنا بتظهر صفحات المنتجات / الإضافة / التعديل */}
      </div>
    </div>
  );
};

export default AdminLayout;
